import React from 'react';

import { Box, Link, Typography } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

import { ACTIVATION_GUIDE_URL } from '../utils/activationLink';

const ActivationLinkWarning = () => (
  <Box
    bgcolor="#fff8e1"
    borderLeft="4px solid #ffa000"
    display="flex"
    alignItems="flex-start"
    p={2}
  >
    <Box mr={1} mt="2px" color="#ff8f00">
      <WarningIcon fontSize="small" />
    </Box>
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        No activation link in this email
      </Typography>
      <Typography variant="body2" gutterBottom>
        This email does not contain {'{{activation_url}}'}. Students may not
        have a clear way to set their password and access Student Portal. The
        system will append a fallback CTA at the end of the email instead.
      </Typography>
      <Link
        href={ACTIVATION_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
      >
        How activation links work
      </Link>
    </Box>
  </Box>
);

export default ActivationLinkWarning;
